export const PORTAL_FILTERS = [
  { id: "all", label: "All portals" },
  { id: "magicbricks", label: "Magic Bricks" },
  { id: "housing", label: "Housing" },
  { id: "ninety_nine_acres", label: "99 Acres" },
] as const;

export type PortalFilterId = (typeof PORTAL_FILTERS)[number]["id"];

export function portalLabelFromRow(row: any): string {
  const portal = String(row?.portal || "").toUpperCase();
  const uid = String(row?.project_uid || "");
  if (portal === "MAGICBRICKS" || uid.startsWith("MB_")) return "Magic Bricks";
  if (portal === "HOUSING" || uid.startsWith("HC_")) return "Housing";
  if (portal === "NINETY_NINE_ACRES" || uid.startsWith("AC_")) return "99 Acres";
  return "Other";
}

export function portalChipColor(
  label: string
): "primary" | "secondary" | "success" | "default" {
  if (label === "Magic Bricks") return "primary";
  if (label === "Housing") return "secondary";
  if (label === "99 Acres") return "success";
  return "default";
}

export function filterPortalRows(rows: any[], portal: string): any[] {
  if (!portal || portal === "all") return rows;
  return rows.filter((row) => {
    const uid = String(row?.project_uid || "");
    const portalField = String(row?.portal || "").toUpperCase();
    if (portal === "magicbricks") {
      return uid.startsWith("MB_") || portalField === "MAGICBRICKS";
    }
    if (portal === "housing") {
      return uid.startsWith("HC_") || portalField === "HOUSING";
    }
    if (portal === "ninety_nine_acres") {
      return uid.startsWith("AC_") || portalField === "NINETY_NINE_ACRES";
    }
    return true;
  });
}

export function mappingStatusLabel(status: string | number): string {
  const s = String(status);
  if (s === "2") return "Ready to move";
  if (s === "1") return "Needs Lead Form";
  return "Needs mapping";
}
